import "../index.css";

export default function Contact() {
  return (
    <div>

      <div className="hero">

        <div className="hero-content">
		
        <h1>Contact Us</h1>

        <p>
          <b>Charudatta Rane (Director):</b> <i>Mobile:</i> +91 98230 44534 /{" "}
          <i>Email:</i> charudatta.rane@outlook.com
        </p>

        <p>
          <b>Bidhan Bhakta (Technical SME):</b> <i>Mobile:</i> +91 99239 74533
        </p>

        <p>
          <b>Office Mobile:</b> +91 91750 02621
        </p>

        <p>
          <b>Office Email:</b> southernrewinds@gmail.com
        </p>

        <p>
          <b>Address:</b> W-241, J-Block, MIDC, Bhosari, Pune - 411026
        </p>
		<p><br /></p>
		  <h2>Our Location</h2>
          <iframe
            title="SPSR Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.643486199268!2d73.83546457579881!3d18.63509856566473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c78c00000001%3A0x94858a5433f44b3d!2sSouthern%20Powersystem%20Rewinds%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1771059729069!5m2!1sen!2sin"
            width="100%"
            height="300"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
	  </div> 

      </div>

    </div>
  );
}
